import { useDialog } from 'muibox';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

export interface InventoryPostResult {
    postId: number;
    postUrl: string;
}

const useInventoryPostToOnlyFans = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const dialog = useDialog();
    const axios = useAxios();
    const { data: subscriber } = useSubscriber();

    const [isPosting, setIsPosting] = useState<boolean>(false);

    const postInventoryVariation = async (inventoryId: number, inventorySubId: number): Promise<InventoryPostResult | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !('userId' in params) || !params.userId || !subscriber) {
            return null;
        }

        const query = `${settingsContext.routes.onlyFans.base}${params.userId}/posts`;

        setIsPosting(true);

        const data = await axios
            .post(query, { inventoryId, inventorySubId })
            .then(response => {
                if (response.status === 200) {
                    return response.data as InventoryPostResult;
                }

                return Promise.reject(response.data);
            })
            .catch(error => {
                console.error(error);

                handleHttpError(error, dialog);

                return null;
            })
            .finally(() => {
                setIsPosting(false);
            });

        return data;
    };

    return { postInventoryVariation, isPosting };
};

export default useInventoryPostToOnlyFans;
